import type { ClientAccessDecision } from './accessResolver';

export type MediaPlaybackStopDecision = {
	kind: 'stop';
	reason: 'final_chapter' | 'chapter_count_unavailable';
};

export type MediaPlaybackBoundaryDecision =
	| { kind: 'next'; nextChapter: number }
	| MediaPlaybackStopDecision;

export type MediaPlaybackEndedDecision =
	| { kind: 'advance'; nextChapter: number }
	| { kind: 'gate'; nextChapter: number; decision: ClientAccessDecision }
	| MediaPlaybackStopDecision;

export function classifyMediaPlaybackBoundary(input: {
	currentChapter: number;
	totalChapters: number;
}): MediaPlaybackBoundaryDecision {
	if (!isPositiveInteger(input.currentChapter) || !isPositiveInteger(input.totalChapters)) {
		return { kind: 'stop', reason: 'chapter_count_unavailable' };
	}
	if (input.currentChapter >= input.totalChapters) {
		return { kind: 'stop', reason: 'final_chapter' };
	}
	return { kind: 'next', nextChapter: input.currentChapter + 1 };
}

export function decideMediaPlaybackEnd(input: {
	currentChapter: number;
	totalChapters: number;
	accessDecision: ClientAccessDecision;
}): MediaPlaybackEndedDecision {
	const boundary = classifyMediaPlaybackBoundary(input);
	if (boundary.kind === 'stop') return boundary;
	if (input.accessDecision.kind !== 'allow') {
		return { kind: 'gate', nextChapter: boundary.nextChapter, decision: input.accessDecision };
	}
	return { kind: 'advance', nextChapter: boundary.nextChapter };
}

function isPositiveInteger(value: number): boolean {
	return Number.isInteger(value) && value > 0;
}
